/*
 * Copyright (c) 2025 CalAmp Corp. All Rights Reserved 
 */
import React, {useCallback} from 'react';
import Render from '@ion/dls/src/render/Render';
import VehicleDetailsEditor from '../vehicle/manager/VehicleDetailsEditor';

export interface SelectedVehicleType {
  vinId: string;
  testProfile: string;
}

export interface VehicleDetailsDialogProps {
  setSelectedVehicle: Function;
  selectedVehicle: SelectedVehicleType;
}

/**
 * Holds dialog functionality for view Vehicle VIn History details.
 */
const VehicleDetailsDialog = ({
  setSelectedVehicle,
  selectedVehicle
}: VehicleDetailsDialogProps) => {
  const {vinId, testProfile} = selectedVehicle || {};

  const onCloseVehicleReport = useCallback(() => {
    setSelectedVehicle(null);
  }, []);

  return (
    <Render.If condition={vinId}>
      <VehicleDetailsEditor onClose={onCloseVehicleReport}
        vinId={vinId}
        activeTab={testProfile} />
    </Render.If>
  );
};

export default VehicleDetailsDialog;
